/**
 * Script pour la page panier - Correction mobile uniquement
 * Version non-intrusive qui préserve l'expérience PC
 */

// Détecter si on est sur mobile
function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
         window.innerWidth <= 768;
}

// Variable pour éviter les loops infinies
let fixAttempted = false;
let pageLoadTime = Date.now();

// Fonction pour corriger les images manquantes du panier (mobile uniquement)
function fixCartImages() {
  if (!isMobile()) return;
  
  console.log('Correction des images du panier (mobile)...');
  
  // Chercher les images cassées ou manquantes
  const images = document.querySelectorAll('.cart img, .cart-item img, [class*="cart"] img');
  
  images.forEach(img => {
    // Vérifier si l'image est cassée ou n'a pas de src
    if (!img.src || img.src === '' || img.naturalWidth === 0) {
      console.log('Image cassée détectée:', img);
      
      // Essayer de recharger l'image sans forcer
      const originalSrc = img.src;
      if (originalSrc) {
        img.src = originalSrc + '?refresh=' + Date.now();
      }
    }
  });
}

// Fonction pour détecter les prix à 0 (mobile uniquement, non-intrusive)
function detectZeroPrices() {
  if (!isMobile()) return false;
  
  const priceSelectors = [
    '.money', 
    '.shopify-Price-amount', 
    '.cart-item-price',
    '.item-price',
    '.price'
  ];
  
  let hasZeroPrices = false;
  
  priceSelectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(element => {
      const text = element.textContent || element.innerText || '';
      if ((text.includes('0.00') || text.includes('0,00') || text.trim() === '0' || text === '0 dhs') && 
          text !== '0 articles') { // Éviter les compteurs d'articles
        console.log('Prix à 0 détecté (mobile):', element, 'Texte:', text);
        hasZeroPrices = true;
      }
    });
  });
  
  return hasZeroPrices;
}

// Fonction pour correction douce mobile (pas d'actualisation forcée)
async function gentleMobileFix() {
  if (!isMobile() || fixAttempted) return;
  
  // Éviter les tentatives répétées trop rapidement
  if (Date.now() - pageLoadTime < 5000) {
    console.log('Trop tôt pour la correction mobile, attente...');
    return;
  }
  
  console.log('Tentative de correction douce mobile...');
  fixAttempted = true;
  
  try {
    // Essayer de récupérer les données du panier sans forcer de mise à jour
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Cache-Control': 'no-cache'
      }
    });
    
    if (response.ok) {
      const cartData = await response.json();
      console.log('Données du panier (mobile):', cartData);
      
      // Vérifier s'il y a des items calculateur avec prix 0
      let hasCalculatorItemsWithZeroPrice = false;
      
      cartData.items.forEach(item => {
        const hasCalculatorProps = item.properties && 
          (item.properties['Largeur ( veuillez utiliser un point ex : 1.2) (m)'] || 
           item.properties['Hauteur ( veuillez utiliser un point ex : 1.2) (m)']);
           
        if (item.price === 0 && hasCalculatorProps) {
          console.log('Item calculateur avec prix 0 (mobile):', item);
          hasCalculatorItemsWithZeroPrice = true;
        }
      });
      
      // Si problème détecté, suggérer à l'utilisateur d'utiliser le bouton
      if (hasCalculatorItemsWithZeroPrice) {
        console.log('Problème de prix détecté sur mobile - suggestion au user');
        showMobileUpdateSuggestion();
      }
    }
  } catch (error) {
    console.log('Erreur lors de la vérification mobile:', error);
  }
}

// Fonction pour mise à jour automatique sur toutes les plateformes
async function autoUpdateCart() {
  console.log('Mise à jour automatique du panier...');
  
  try {
    // Récupérer les données du panier
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Cache-Control': 'no-cache'
      }
    });
    
    if (response.ok) {
      const cartData = await response.json();
      console.log('Données du panier récupérées:', cartData);
      
      // Vérifier s'il y a des items calculateur avec prix 0
      let needsUpdate = false;
      const updates = {};
      
      cartData.items.forEach(item => {
        const hasCalculatorProps = item.properties && 
          (item.properties['Largeur ( veuillez utiliser un point ex : 1.2) (m)'] || 
           item.properties['Hauteur ( veuillez utiliser un point ex : 1.2) (m)']);
           
        if (item.price === 0 && hasCalculatorProps) {
          console.log('Item calculateur avec prix 0 détecté:', item);
          needsUpdate = true;
          // Maintenir la quantité actuelle pour forcer la mise à jour
          updates[item.key] = item.quantity;
        }
      });
      
      if (needsUpdate) {
        console.log('Mise à jour du panier nécessaire, updates:', updates);
        
        // Utiliser /cart/update.js avec les keys
        const updateResponse = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ updates })
        });
        
        if (updateResponse.ok) {
          console.log('Panier mis à jour avec succès');
          // Attendre un peu puis recharger la page
          setTimeout(() => {
            console.log('Rechargement de la page pour afficher les prix corrects...');
            window.location.reload();
          }, 1000);
          return true;
        } else {
          console.error('Erreur lors de la mise à jour:', updateResponse.status);
        }
      } else {
        console.log('Aucune mise à jour nécessaire - tous les prix sont corrects');
      }
    } else {
      console.error('Erreur lors de la récupération du panier:', response.status);
    }
  } catch (error) {
    console.error('Erreur lors de la mise à jour automatique:', error);
  }
  
  return false;
}

// Fonction pour suggérer à l'utilisateur d'utiliser le bouton de mise à jour
function showMobileUpdateSuggestion() {
  // Chercher le bouton de mise à jour
  const updateButtons = document.querySelectorAll('button[type="submit"], .button, input[type="submit"]');
  let updateButton = null;
  
  updateButtons.forEach(button => {
    const buttonText = button.textContent || button.value || '';
    if (buttonText.toLowerCase().includes('mettre à jour') || 
        buttonText.toLowerCase().includes('update')) {
      updateButton = button;
    }
  });
  
  if (updateButton) {
    // Ajouter un style visuel discret pour attirer l'attention
    updateButton.style.animation = 'pulse 1s ease-in-out 3';
    updateButton.style.boxShadow = '0 0 10px rgba(255, 193, 7, 0.6)';
    
    // Créer un petit message d'aide mobile
    if (!document.getElementById('mobile-update-hint')) {
      const hint = document.createElement('div');
      hint.id = 'mobile-update-hint';
      hint.style.cssText = `
        background: #fff3cd;
        border: 1px solid #ffeaa7;
        padding: 8px 12px;
        margin: 10px 0;
        border-radius: 4px;
        font-size: 13px;
        color: #856404;
        text-align: center;
      `;
      hint.textContent = '💡 Appuyez sur "Mettre à jour" pour actualiser les prix';
      
      updateButton.parentNode.insertBefore(hint, updateButton);
      
      // Retirer le message après 10 secondes
      setTimeout(() => {
        if (hint && hint.parentNode) {
          hint.parentNode.removeChild(hint);
        }
        updateButton.style.animation = '';
        updateButton.style.boxShadow = '';
      }, 10000);
    }
  }
}

// Initialisation douce
function initCartPriceFix() {
  // Vérifier si nous sommes sur la page panier
  if (!window.location.pathname.includes('/cart')) {
    return;
  }
  
  console.log('Initialisation correction panier:', isMobile() ? 'Mobile' : 'Desktop');
  
  // Sur mobile - correction des images et suggestion douce
  if (isMobile()) {
    // Correction des images immédiatement
    setTimeout(fixCartImages, 1000);
    
    // Vérification des prix après chargement complet
    setTimeout(() => {
      if (detectZeroPrices()) {
        gentleMobileFix();
      }
    }, 3000);
  }
  
  // Sur toutes les plateformes - mise à jour automatique si prix à 0 détectés
  else {
    console.log('Desktop détecté - vérification et mise à jour automatique');
    
    // Attendre le chargement complet puis vérifier
    setTimeout(async () => {
      // Détecter les prix à 0 (version desktop)
      const priceSelectors = [
        '.money', 
        '.shopify-Price-amount', 
        '.cart-item-price',
        '.item-price',
        '.price'
      ];
      
      let hasZeroPrices = false;
      
      priceSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
          const text = element.textContent || element.innerText || '';
          if ((text.includes('0.00') || text.includes('0,00') || text.trim() === '0' || text === '0 dhs') && 
              text !== '0 articles') {
            console.log('Prix à 0 détecté (desktop):', element, 'Texte:', text);
            hasZeroPrices = true;
          }
        });
      });
      
      // Si prix à 0 détectés, faire la mise à jour automatique
      if (hasZeroPrices) {
        console.log('Prix à 0 détectés sur desktop - mise à jour automatique...');
        await autoUpdateCart();
      } else {
        console.log('Tous les prix sont corrects sur desktop');
      }
    }, 2000);
  }
}

// Initialiser
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartPriceFix);
} else {
  initCartPriceFix();
}

// Export pour utilisation externe - version conservatrice
window.CartPriceFix = {
  isMobile: isMobile,
  fixImages: fixCartImages,
  detectZeroPrices: detectZeroPrices,
  gentleFix: gentleMobileFix,
  autoUpdate: autoUpdateCart
};
